<template>
    <b-table
      :items="listings"
      :fields="[
        {key: 'id', label: 'Id'},
        {key: 'name', label: 'Name'},
        {key: 'select', label: 'Select'},
      ]"
    >
      <template v-slot:cell(select)="data">
        <b-button variant="danger" v-on:click="onRemoval(data)">
          Remove
        </b-button>
      </template>
    </b-table>
</template>

<script>
    export default {
      name: "SelectedAudience",
      props: {
        listings: {
          type: Array,
          default: new Array(),
        }
      },
      methods: {
        onRemoval(data) {
          this.$emit('removed', data.item);
        }
      }
    }
</script>

<style scoped>

</style>
